/**
 * <ActivationProductCard> — le produit d'appel de la famille : lequel, et jusqu'à quand (molecule).
 *
 * Volontairement plus maigre que `<SubscriptionStateCard>` : statut Stripe et prochain prélèvement
 * sont des données de compte, hors de ce qu'un lien transférable a le droit de lire
 * (`ActivationLandingScreen.js:363-380`).
 *
 * ⚠️ Sans produit nommé, la carte NE SE REND PAS — et c'est elle qui le garantit, pas ses
 * appelants. Son repli « Abonnement en cours » affirmait un abonnement à des familles qui n'en
 * avaient jamais eu ; vu en production sur un stagiaire jamais abonné.
 *
 * La flamme suit la COUVERTURE, pas la carte : « Stage · s'est terminé le 14 août » sous un signal
 * « en cours » se contredit dans la même ligne.
 */
import React from "react"
import { StyleSheet } from "react-native-unistyles"

import { Card } from "../Card"
import { Icon } from "../../atoms/icons/Icon"
import { Row } from "../../atoms/containers/Row"
import { Stack } from "../../atoms/containers/Stack"
import { Text } from "../../atoms/typography/Text"
import { type UIActivationProduct } from "../../../ports/primary/ui/types"

export type ActivationProductCardProps = {
    /** Le produit — absent, ou sans nom, la carte ne rend rien. */
    product?: UIActivationProduct | null
    testID?: string
}

export function ActivationProductCard(props: ActivationProductCardProps) {
    const { product, testID } = props

    if (product == null || product.label === "") return null

    const { label, endLine, running = false } = product

    return (
        <Card p="4" testID={testID}>
            <Stack gap="1">
                <Row gap="2">
                    <Text size="text-md" weight="bold" color="primary" style={styles.label}>
                        {label}
                    </Text>
                    {/* La flamme est une marque d'état : elle se remplit. */}
                    {running && <Icon name="fire" size={16} color="warning" solid />}
                </Row>
                {endLine != null && endLine !== "" && (
                    <Text size="text-sm" weight="semibold" color="text-muted">
                        {endLine}
                    </Text>
                )}
            </Stack>
        </Card>
    )
}

const styles = StyleSheet.create(() => ({
    /** Le nom du produit se replie ; la flamme reste collée à lui. */
    label: { flexShrink: 1 },
}))
